import React from 'react'

const PIECES = [
  { top: '3%', left: '6%', size: 14, color: '#F6C945', shape: 'rect', rotate: -25 },
  { top: '9%', left: '16%', size: 10, color: '#34C759', shape: 'circle' },
  { top: '4%', left: '28%', size: 12, color: '#F08FB4', shape: 'square', rotate: 20 },
  { top: '14%', left: '4%', size: 12, color: '#7EC8E3', shape: 'square', rotate: -15 },
  { top: '2%', left: '42%', size: 10, color: '#8B5CF6', shape: 'circle' },
  { top: '11%', left: '36%', size: 14, color: '#F6C945', shape: 'rect', rotate: 30 },
  { top: '6%', left: '58%', size: 12, color: '#34C759', shape: 'square', rotate: 12 },
  { top: '16%', left: '66%', size: 10, color: '#F08FB4', shape: 'circle' },
  { top: '3%', left: '74%', size: 14, color: '#7EC8E3', shape: 'rect', rotate: -18 },
  { top: '10%', left: '84%', size: 12, color: '#8B5CF6', shape: 'square', rotate: 24 },
  { top: '5%', left: '92%', size: 10, color: '#F6C945', shape: 'circle' },
  { top: '20%', left: '94%', size: 12, color: '#34C759', shape: 'rect', rotate: -10 },
  { top: '82%', left: '5%', size: 12, color: '#F08FB4', shape: 'square', rotate: 16 },
  { top: '90%', left: '14%', size: 10, color: '#7EC8E3', shape: 'circle' },
  { top: '86%', left: '24%', size: 14, color: '#F6C945', shape: 'rect', rotate: 22 },
  { top: '94%', left: '38%', size: 10, color: '#8B5CF6', shape: 'circle' },
  { top: '84%', left: '54%', size: 12, color: '#34C759', shape: 'square', rotate: -20 },
  { top: '92%', left: '64%', size: 12, color: '#F08FB4', shape: 'rect', rotate: 14 },
  { top: '80%', left: '78%', size: 10, color: '#7EC8E3', shape: 'circle' },
  { top: '90%', left: '88%', size: 14, color: '#F6C945', shape: 'square', rotate: -28 },
  { top: '88%', left: '96%', size: 10, color: '#8B5CF6', shape: 'circle' },
  { top: '40%', left: '2%', size: 10, color: '#34C759', shape: 'circle' },
  { top: '55%', left: '96%', size: 12, color: '#F08FB4', shape: 'square', rotate: 18 },
  { top: '30%', left: '96%', size: 10, color: '#7EC8E3', shape: 'circle' }
]

export default function ConfettiBurst() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
      {
        PIECES.map((piece, index) => (
          <span
            key={index}
            className={piece.shape === 'circle' ? 'absolute rounded-full' : piece.shape === 'rect' ? 'absolute rounded-sm' : 'absolute rounded-[2px]'}
            style={{
              top: piece.top,
              left: piece.left,
              width: piece.shape === 'rect' ? piece.size * 0.55 : piece.size,
              height: piece.shape === 'rect' ? piece.size * 1.7 : piece.size,
              backgroundColor: piece.color,
              transform: `rotate(${piece.rotate || 0}deg)`
            }}
          />
        ))
      }
    </div>
  )
}
